import { faCartShopping, faFileInvoiceDollar, faFilePdf, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons"
import MenuItem from "../../../types/menu/MenuItem"

const LTCNavListInternal: MenuItem[] = [
    {
        id: 1,
        name: 'summaryReview',
        complete: false,
        componentName: 'Summary',
        icon: faFilePdf
    },
    {
        id: 2,
        name: 'contactInfo',
        componentName: 'ContactInfo',
        complete: false,
    },
    {
        id: 3,
        name: 'incomeExpense',
        componentName: 'IncomeExpense',
        complete: false,
        icon: faMoneyBillTrendUp,
        subItems: [
            {
                id: 31,
                name: 'bedCounts',
                complete: false,
                componentName: "BedCounts"
            },
            {
                id: 32,
                name: 'revenue',
                complete: false,
                componentName: "Subsidy",
                hasTabs: true,
                subItems: [
                    {
                        id: 321,
                        name: 'revenue',
                        complete: false
                    },
                    {
                        id: 322,
                        name: 'nonOperatingIncomeRevenues',
                        complete: false
                    },
                    {
                        id: 323,
                        name: 'rentalLoss',
                        complete: false
                    }
                ]
            },
            {
                id: 33,
                name: 'expenses',
                componentName: 'ExpenseContainer',
                hasTabs: true,
                complete: false,
                subItems: [
                    {
                        id: 331,
                        name: 'operatingExpenses',
                        complete: false
                    },
                    {
                        id: 332,
                        name: 'fixedCharges',
                        complete: false
                    },
                    {
                        id: 333,
                        name: 'nonOperatingIncomeExpenses',
                        complete: false
                    }
                ]
            },
            {
                id: 34,
                name: 'reserveForReplacementAllowance',
                componentName: 'ReserveForReplacementAllowance',
                complete: false,
            },
            {
                id: 35,
                name: 'capitalExpSummary',
                complete: false,
                componentName: 'CapitalCostsSummary'
            },
            {
                id: 36,
                name: 'analysis',
                componentName: 'Analysis',
                complete: false
            }
        ],
    },
    {
        id: 4,
        name: 'commercial',
        complete: false,
        icon: faCartShopping,
        subItems: [
            {
                id: 41,
                name: 'leaseInformationTable',
                componentName: 'LeaseInfo',
                complete: false
            },
            {
                id: 42,
                name: 'vacantAskingRate',
                complete: false,
                componentName: 'VacantAskingRate',
            },
            {
                id: 43,
                name: 'parkingSummary',
                complete: false,
                componentName: 'ParkingPropertySummary',
            }
        ]
    },
    {
        id: 5,
        name: 'comments',
        complete: false,
        componentName: 'Comment'
    },
    {
        id: 6,
        name: 'submit',
        complete: false,
        componentName: 'Submit',
        icon: faFileInvoiceDollar
    }
]

export default LTCNavListInternal